// extracted by mini-css-extract-plugin
module.exports = {"selector":"filterByType_selector__3bcHe","text_order":"filterByType_text_order__3AJ2y"};